import React from 'lib/react';
import { EVGrid, EVTypography, makeStyles } from 'lib/components';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  pageHeadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    borderRadius: '0px 4px 0px 0px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
  },
  headerTitle: {
    color: theme.evPalette.charcoal[900],
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '36px',
  },
  headerDesc: {
    color: theme.evPalette.charcoal[800],
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    margin: 'auto 0px',
  },
}));

function PageHeading(props) {
  const { title, description } = props;
  const classes = useStyles();
  return (
    <EVGrid className={classes.pageHeadingContainer}>
      <EVTypography className={classes.headerTitle}>{title}</EVTypography>
      <EVTypography className={classes.headerDesc}>{description}</EVTypography>
    </EVGrid>
  );
}

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default PageHeading;
